import React, { useState } from "react"
import ChoicesInput from "./ChoicesInput"
import SliceColors from "../shared/SliceColors"
import { PLACEHOLDER_SLOTS } from "../shared/SpinWheel"
import { loginGuardProps } from "../../helpers/auth"

const TABS = {
  CHOICES: "choices",
  COLORS: "colors",
}

const ChoicesTabContainer = ({
  value,
  onChange,
  isLoggedIn,
  choices,
  customColors,
  onColorChange,
  onResetAllColors,
}) => {
  const [activeTab, setActiveTab] = useState(TABS.CHOICES)
  const isChoicesTab = activeTab === TABS.CHOICES
  const isColorsTab = activeTab === TABS.COLORS

  return (
    <>
      <div className="section-label">Choices</div>
      <div className="choices-tabs">
        <button
          className={`choices-tab ${isChoicesTab ? "choices-tab-active" : ""}`}
          onClick={() => setActiveTab(TABS.CHOICES)}
        >
          Choices
        </button>
        <button
          className={`choices-tab ${isColorsTab ? "choices-tab-active" : ""} ${isLoggedIn ? "" : "choices-tab-disabled"}`}
          onClick={() => setActiveTab(TABS.COLORS)}
          {...loginGuardProps(isLoggedIn, "Customize slice colors")}
        >
          Colors
          {!isLoggedIn && <span className="choices-tab-lock">*</span>}
        </button>
      </div>
      <div className="choices-tab-content">
        <div className="choices-tab-panel">
          {isChoicesTab ? (
            <ChoicesInput value={value} onChange={onChange} />
          ) : (
            <SliceColors
              choices={choices.length > 0 ? choices : PLACEHOLDER_SLOTS}
              customColors={customColors}
              onColorChange={onColorChange}
              onResetAll={onResetAllColors}
            />
          )}
        </div>
      </div>
    </>
  )
}

export default ChoicesTabContainer
